import { render, staticRenderFns } from "./ButtonFive.vue?vue&type=template&id=7f039d5d&"
import script from "./ButtonFive.vue?vue&type=script&lang=ts&"
export * from "./ButtonFive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports